import script from "./studyItemNormal2.vue?vue&type=script&setup=true&lang=js"
export * from "./studyItemNormal2.vue?vue&type=script&setup=true&lang=js"

import "./studyItemNormal2.vue?vue&type=style&index=0&id=32986bf6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32986bf6"]])

export default __exports__